/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { socketConnection } from "../../_helpers/socket";
import { getProfile } from "../../Redux/userSlice";
import { toast } from "sonner";

const PermissionNotAllowed = React.lazy(
  () => import("../Atoms/PermissionsNotAllowed/PermissionNotAllowed"),
);
const ProductOptionValue = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductOptions/ProductOptionValue"),
);
const Preferences = React.lazy(
  () => import("../../pages/UserManagement/preferences/Preferences"),
);
const Tax = React.lazy(() => import("../../pages/Admin/Tax/Tax"));
const FAQs = React.lazy(() => import("../../pages/CMS/FAQs/FAQ"));
const FAQList = React.lazy(() => import("../../pages/CMS/FAQs/FAQList"));
const ShippingDurations = React.lazy(
  () =>
    import("../../pages/ShippingPickup/ShippingDurations/ShippingDurations"),
);
const SubTax = React.lazy(() => import("../../pages/Admin/Tax/SubTax"));
const TaxRule = React.lazy(
  () => import("../../pages/Admin/Tax/TaxRule/TaxRule"),
);
const Badge = React.lazy(() => import("../../pages/Admin/Badge/Badge"));
const TermsConditions = React.lazy(
  () => import("../../pages/CMS/Terms&Conditions/Terms&Conditions"),
);
const TermsConditionsList = React.lazy(
  () => import("../../pages/CMS/Terms&Conditions/Terms&ConditionsList"),
);
const PrivacyPolicyCategory = React.lazy(
  () => import("../../pages/CMS/PrivacyPolicy/PrivacyPolicy"),
);
const PrivacyPolicyList = React.lazy(
  () => import("../../pages/CMS/PrivacyPolicy/PrivacyPolicyList"),
);
const PaymentPolicy = React.lazy(
  () => import("../../pages/CMS/PaymentPolicies/PaymentPolicies"),
);
const PaymentPolicyList = React.lazy(
  () => import("../../pages/CMS/PaymentPolicies/PaymentPoliciesList"),
);
const Holidays = React.lazy(() => import("../../pages/CMS/Holidays/Holidays"));
const HolidaysList = React.lazy(
  () => import("../../pages/CMS/Holidays/HolidaysList"),
);
const ReturnPolicy = React.lazy(
  () => import("../../pages/CMS/ReturnPolicy/ReturnPolicy"),
);
const ReturnPolicyList = React.lazy(
  () => import("../../pages/CMS/ReturnPolicy/ReturnPolicyList"),
);
const PromotionBanners = React.lazy(
  () => import("../../pages/Promotions/PromotionsBanners/PromotionBanners"),
);
const PostManagement = React.lazy(
  () => import("../../pages/SocialManagement/Post/PostManagement"),
);
const ForumManagement = React.lazy(
  () => import("../../pages/SocialManagement/Forums/ForumManagement"),
);
const CommunityGroupManagement = React.lazy(
  () => import("../../pages/SocialManagement/Community/CommunityGroupManagement"),
);
const HelpSupport = React.lazy(
  () => import("../../pages/HelpSupport/HelpSupport"),
);
const HelpSupportList = React.lazy(
  () => import("../../pages/HelpSupport/HelpSupportList"),
);
const SupportTicket = React.lazy(
  () => import("../../pages/Support/SupportTicket"),
);
const ContactUs = React.lazy(() => import("../../pages/contact-us/ContactUs"));
const InventoryForm = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductCatalog/components/InventoryForm"),
);
const Inventory = React.lazy(() => import("../../pages/inventory/Inventory"));
const ProductInventory = React.lazy(
  () => import("../../pages/inventory/product-Inventory/ProductInventory"),
);
const PickupAddress = React.lazy(
  () => import("../../pages/PickupAddress/PickupAddress"),
);
const ProductReviews = React.lazy(
  () => import("../../pages/OrdersManagement/Orders/components/ProductReviews"),
);
const ReturnAddress = React.lazy(
  () => import("../../pages/pickup history/ReturnAddress"),
);
const OrderCancellations = React.lazy(
  () =>
    import("../../pages/OrdersManagement/Order Cancellations/OrderCancellations"),
);
const OrderReturn = React.lazy(
  () => import("../../pages/OrdersManagement/Order Return/OrderReturn"),
);
const DeliveryPartner = React.lazy(
  () => import("../../pages/Admin/Devilry Partner/DevilryPartner"),
);
const DesignerMessage = React.lazy(
  () => import("../../pages/DesignerMessage/DesignerMessage"),
);
const CustomOrders = React.lazy(
  () => import("../../pages/CustomOrders/CustomOrders"),
);
const ViewCustomOrders = React.lazy(
  () => import("../../pages/CustomOrders/components/ViewCustomOrders"),
);
const CustomRequirements = React.lazy(
  () => import("../../pages/CustomRequirements/CustomRequirements"),
);
const StorePayouts = React.lazy(
  () => import("../../pages/StorePayouts/StorePayouts"),
);
const ActiveDesigners = React.lazy(
  () => import("../../pages/ActiveDesigners/ActiveDesigners"),
);
const RetryOnboarding = React.lazy(
  () => import("../../pages/ProductManagement/Store/RetryOnBoarding"),
);
const OnboardingSuccess = React.lazy(
  () => import("../../pages/ProductManagement/Store/OnboardingSuccess"),
);
const BulkProductHistory = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductCatalog/BulkProductHistory"),
);
const BoostProduct = React.lazy(
  () => import("../../pages/ProductManagement/ProductCatalog/BoostProduct"),
);
const ImageGalleryList = React.lazy(
  () => import("../../pages/ProductManagement/ProductCatalog/ImageGalleryList"),
);
const PromotionAdvertisement = React.lazy(
  () =>
    import("../../pages/Promotions/PromotionsAdvertisement/PromotionAdvertisement"),
);
const Boosts = React.lazy(() => import("../../pages/Promotions/Boosts/Boosts"));
const BulkUploadNew = React.lazy(
  () => import("../../pages/ProductManagement/ProductCatalog/BulUploadNew"),
);
const Dashboard = React.lazy(() => import("../../pages/dashboard/Dashboard"));
const AbandonedCart = React.lazy(
  () => import("../../pages/OrdersManagement/Abandoned Cart/AbandonedCart"),
);
const AdminUsers = React.lazy(
  () => import("../../pages/UserManagement/Adminusers/AdminUsers"),
);
const Users = React.lazy(
  () => import("../../pages/UserManagement/Users/Users"),
);
const UsersAddresses = React.lazy(
  () => import("../../pages/UserManagement/UsersAddresses/UsersAddresses"),
);
const ProductCatalog = React.lazy(
  () => import("../../pages/ProductManagement/ProductCatalog/ProductCatalog"),
);
const SellerProductInventories = React.lazy(
  () =>
    import("../../pages/ProductManagement/SellerProductInventories/SellerProductInventories"),
);
const Store = React.lazy(
  () => import("../../pages/ProductManagement/Store/Store"),
);
const Brands = React.lazy(
  () => import("../../pages/ProductManagement/Brands/Brands"),
);
const ProductOptions = React.lazy(
  () => import("../../pages/ProductManagement/ProductOptions/ProductOptions"),
);
const Orders = React.lazy(
  () => import("../../pages/OrdersManagement/Orders/Orders"),
);
const DiscountCoupons = React.lazy(
  () => import("../../pages/Promotions/DiscountCoupons/DiscountCoupons"),
);
const Ribbons = React.lazy(
  () => import("../../pages/Promotions/Ribbons/Ribbons"),
);
const ShippingCompanyUsers = React.lazy(
  () =>
    import("../../pages/ShippingPickup/ShippingCompanyUsers/ShippingCompanyUsers"),
);
const ShippingPackages = React.lazy(
  () => import("../../pages/ShippingPickup/ShippingPackages/ShippingPackages"),
);
const ShippingProfiles = React.lazy(
  () => import("../../pages/ShippingPickup/ShippingProfiles/ShippingProfiles"),
);
const PickupAddresses = React.lazy(
  () => import("../../pages/ShippingPickup/PickupAddresses/PickupAddresses"),
);
const AddEditProductPopup = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductCatalog/components/AddEditProduct"),
);
const ProductCategories = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductCategories/ProductCategories"),
);
const OrderSummary = React.lazy(
  () => import("../../pages/OrdersManagement/Orders/components/ViewOrders"),
);
const InterestManagement = React.lazy(
  () =>
    import("../../pages/UserManagement/InterestManagement/InterestManagement"),
);
const Profile = React.lazy(() => import("../../pages/My Profile/Profile"));
const ChangePassword = React.lazy(
  () => import("../../pages/Change Password/ChangePassword"),
);
const TaxStructure = React.lazy(
  () => import("../../pages/Admin/Tax/TaxStructure"),
);
const TaxCategory = React.lazy(
  () => import("../../pages/Admin/Tax/TaxCategory"),
);
const TaxRules = React.lazy(() => import("../../pages/Admin/Tax/TaxRules"));
const Collections = React.lazy(
  () => import("../../pages/Admin/Collection/Collections"),
);
const ProductVariants = React.lazy(
  () => import("../../pages/ProductManagement/ProductVariants/ProductVariants"),
);
const ProductDimensions = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductDimensions/ProductDimensions"),
);
const Pattern = React.lazy(() => import("../../pages/Admin/Pattern/Pattern"));
const FinishProducts = React.lazy(
  () => import("../../pages/ProductManagement/FinishProduct/FinishProduct"),
);
const ColorManagement = React.lazy(
  () => import("../../pages/Admin/Colors/ColorManagement"),
);
const ProductWarranty = React.lazy(
  () => import("../../pages/ProductManagement/ProductWarranty/ProductWarranty"),
);
const Sellers = React.lazy(
  () => import("../../pages/UserManagement/Sellers/Designers"),
);
const UserPermissions = React.lazy(
  () => import("../../pages/UserManagement/Adminusers/UserPermissions"),
);
const BarCode = React.lazy(
  () =>
    import("../../pages/ProductManagement/ProductCatalog/components/BarCode"),
);
const BillingProducts = React.lazy(
  () => import("../../pages/BillingProducts/BillingProducts"),
);
const NotificationList = React.lazy(
  () => import("../../pages/Admin/Notification/NotificationList"),
);
const Settings = React.lazy(() => import("../../pages/Settings/settings"));
const SizeManagement = React.lazy(
  () => import("../../pages/Admin/Colors/SizeManagement"),
);

function Layout() {
  const dispatch = useDispatch();
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [moduleName, setModuleName] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [isRefreshConfig, setIsRefreshConfig] = useState(false);
  const socket = socketConnection();
  const [isPermissionShow, setIsPermissionShow] = useState(false);
  const selector = useSelector((state) => state.user);
  const permissions = selector?.getAllModulePermissionData?.data?.data;
  const [hasPermanentOpen, setHasPermanentOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const triggerAlert = ({ title, body, redirectUrl }) => {
    if (isDisabled) return;

    const showNotification = () => {
      const notification = new Notification(title, {
        body,
        icon: "/favIcon.ico",
      });
      if (redirectUrl) {
        notification.onclick = () => window.open(redirectUrl, "_self");
      }
    };

    if (Notification.permission === "granted") {
      showNotification();
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          showNotification();
        }
      });
    }

    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);
  };

  const fetchUserData = useCallback(async () => {
    try {
      const res = await dispatch(getProfile()).unwrap();
      if (res?.data) {
        setUserData(res.data);
      }
    } catch (error) {
      toast?.info(error);
    }
  }, [dispatch]);

  // Create a mapping of module codes to permission data
  const modulePermissions = useMemo(() => {
    const permMap = {};
    if (permissions && permissions.length) {
      permissions?.forEach((perm) => {
        if (perm.module_code && perm.module_code.module_code) {
          permMap[perm.module_code.module_code] = perm;
        }
      });
    }
    return permMap;
  }, [permissions]);

  const getModulePermission = (moduleCode) => {
    return modulePermissions[moduleCode] || null;
  };

  useEffect(() => {
    socket?.on("refreshed-configurations", (data) => {
      setIsPermissionShow(true);
      setIsRefreshConfig(!isRefreshConfig);
    });

    socket?.on("system-notification", (data) => triggerAlert(data));

    return () => {
      socket?.off("refreshed-configurations");
      socket?.off("system-notification");
    };
  }, [isRefreshConfig, socket]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const hasPermission = (moduleCode) => {
    const permission = modulePermissions[moduleCode];
    return permission ? permission.view : false;
  };

  const renderRoute = (moduleCode, element) => {
    const modulePermission = getModulePermission(moduleCode);
    return hasPermission(moduleCode) ? (
      React.cloneElement(element, {
        modulePermission,
        setModuleName,
        userData,
      })
    ) : (
      <PermissionNotAllowed loading={isPermissionShow} />
    );
  };

  return (
    <div className="flex relative h-screen overflow-hidden">
      <div className={`z-40`}>
        <Sidebar
          navbarOpen={navbarOpen}
          setNavbarOpen={setNavbarOpen}
          setModuleName={setModuleName}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          isRefreshConfig={isRefreshConfig}
          setHasPermanentOpen={setHasPermanentOpen}
        />
      </div>

      <div
        className={`flex flex-col flex-1 overflow-hidden ${navbarOpen ? "" : "lg:ml-0"
          }`}
      >
        <Header
          handleNavbar={() => setNavbarOpen((prev) => !prev)}
          moduleName={moduleName}
          hasPermanentOpen={hasPermanentOpen}
        />

        <main className="flex-1 bg-[#f1edf0] overflow-y-auto pt-16">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route
                path="/home"
                element={renderRoute("home", <Dashboard />)}
              />

              <Route
                path="/admin-users"
                element={renderRoute("admin-users", <AdminUsers />)}
              />
              <Route path="/users" element={renderRoute("users", <Users />)} />
              <Route
                path="/users-addresses"
                element={renderRoute("users-addresses", <UsersAddresses />)}
              />
              <Route
                path="/designers"
                element={renderRoute("designers", <Sellers socket={socket} />)}
              />
              <Route
                path="/interests"
                element={renderRoute("interests", <InterestManagement />)}
              />
              <Route
                path="/preferences"
                element={renderRoute("preferences", <Preferences />)}
              />
              <Route
                path="/contact-us"
                element={renderRoute("contact-us", <ContactUs />)}
              />
              <Route
                path="/support-tickets"
                element={renderRoute(
                  "support-tickets",
                  <SupportTicket userData={userData} socket={socket} />,
                )}
              />

              <Route
                path="/product-catalog"
                element={renderRoute(
                  "product-catalog",
                  <ProductCatalog userData={userData} />,
                )}
              />

              <Route
                path="/product-catalog/bulk-upload"
                element={<BulkUploadNew userData={userData} />}
              />

              <Route
                path="/product-catalog/bulk-product-history"
                element={<BulkProductHistory userData={userData} />}
              />
              <Route
                path="/product-inventory"
                element={renderRoute(
                  "product-inventory",
                  <Inventory userData={userData} />,
                )}
              />
              <Route
                path="/categories"
                element={renderRoute(
                  "categories",
                  <ProductCategories userData={userData} />,
                )}
              />
              <Route
                path="/brands"
                element={renderRoute("brands", <Brands userData={userData} />)}
              />
              <Route
                path="/product-types"
                element={renderRoute(
                  "product-types",
                  <ProductOptions userData={userData} />,
                )}
              />
              <Route path="/store" element={renderRoute("store", <Store />)} />
              <Route
                path="/collections"
                element={renderRoute(
                  "collections",
                  <Collections userData={userData} />,
                )}
              />
              <Route
                path="/colors"
                element={renderRoute("colors", <ColorManagement />)}
              />

              <Route
                path="/sizes"
                element={renderRoute("sizes", <SizeManagement />)}
              />

              <Route
                path="/orders"
                element={renderRoute("orders", <Orders />)}
              />
              <Route
                path="/custom-orders"
                element={renderRoute("custom-orders", <CustomOrders />)}
              />
              <Route
                path="/custom-requirements"
                element={renderRoute(
                  "custom-requirements",
                  <CustomRequirements socket={socket} userData={userData} />,
                )}
              />
              <Route
                path="/order-cancellations"
                element={renderRoute(
                  "order-cancellations",
                  <OrderCancellations userData={userData} />,
                )}
              />
              <Route
                path="/store-payouts"
                element={renderRoute("store-payouts", <StorePayouts />)}
              />
              <Route
                path="/active-designers"
                element={renderRoute("home", <ActiveDesigners />)}
              />
              <Route
                path="/order-returns"
                element={renderRoute(
                  "order-returns",
                  <OrderReturn userData={userData} />,
                )}
              />
              <Route
                path="/product-reviews"
                element={renderRoute("product-reviews", <ProductReviews />)}
              />
              <Route
                path="/abandoned-cart"
                element={renderRoute("abandoned-cart", <AbandonedCart />)}
              />

              <Route
                path="/promotions-banners"
                element={renderRoute(
                  "promotions-banners",
                  <PromotionBanners />,
                )}
              />

              <Route
                path="/post"
                element={renderRoute("post", <PostManagement />)}
              />
              <Route
                path="/forums"
                element={renderRoute("forums", <ForumManagement />)}
              />
              <Route
                path="/community"
                element={renderRoute("community", <CommunityGroupManagement />)}
              />

              <Route
                path="/advertisements"
                element={renderRoute(
                  "advertisements",
                  <PromotionAdvertisement />,
                )}
              />
              <Route
                path="/discount-coupons"
                element={renderRoute("discount-coupons", <DiscountCoupons />)}
              />
              <Route
                path="/badges"
                element={renderRoute("badges", <Badge />)}
              />
              <Route
                path="/ribbons"
                element={renderRoute("ribbons", <Ribbons />)}
              />

              <Route
                path="/terms-and-conditions"
                element={renderRoute(
                  "terms-and-conditions",
                  <TermsConditions
                    modulePermission={getModulePermission(
                      "terms-and-conditions",
                    )}
                  />,
                )}
              />
              <Route
                path="/privacy-policies"
                element={renderRoute(
                  "privacy-policies",
                  <PrivacyPolicyCategory
                    modulePermission={getModulePermission("privacy-policies")}
                  />,
                )}
              />
              <Route
                path="/faqs"
                element={renderRoute(
                  "faqs",
                  <FAQs modulePermission={getModulePermission("faqs")} />,
                )}
              />
              <Route
                path="/payment-policy"
                element={renderRoute(
                  "payment-policy",
                  <PaymentPolicy
                    modulePermission={getModulePermission("payment-policy")}
                  />,
                )}
              />
              <Route
                path="/return-policy"
                element={renderRoute(
                  "return-policy",
                  <ReturnPolicy
                    modulePermission={getModulePermission("return-policy")}
                  />,
                )}
              />
              <Route
                path="/holidays"
                element={renderRoute(
                  "holidays",
                  <Holidays
                    modulePermission={getModulePermission("holidays")}
                  />,
                )}
              />
              <Route
                path="/tax"
                element={renderRoute(
                  "tax",
                  <Tax modulePermission={getModulePermission("tax")} />,
                )}
              />
              <Route
                path="/tax-rule"
                element={renderRoute(
                  "tax-rule",
                  <TaxRule
                    modulePermission={getModulePermission("tax-rule")}
                  />,
                )}
              />
              <Route
                path="/seller-Product-Inventory"
                element={renderRoute(
                  "product-inventory",
                  <SellerProductInventories />,
                )}
              />
              <Route
                path="/shipping-company-users"
                element={renderRoute(
                  "shipping-company-users",
                  <ShippingCompanyUsers />,
                )}
              />
              <Route
                path="/shipping-packages"
                element={renderRoute("shipping-packages", <ShippingPackages />)}
              />
              <Route
                path="/shipping-profile"
                element={renderRoute("shipping-profile", <ShippingProfiles />)}
              />
              <Route
                path="/pickup-addresses"
                element={renderRoute("pickup-addresses", <PickupAddresses />)}
              />
              <Route
                path="/product-catalogs/form/:id?"
                element={renderRoute(
                  "product-catalog",
                  <AddEditProductPopup />,
                )}
              />
              <Route
                path="/product-catalogs/boost/:id?"
                element={<BoostProduct />}
              />
              <Route path="/changePassword" element={<ChangePassword />} />
              <Route
                path="/tax-structure"
                element={renderRoute("tax", <TaxStructure />)}
              />
              <Route
                path="/tax-category"
                element={renderRoute("tax", <TaxCategory />)}
              />
              <Route
                path="/tax-category-rules"
                element={renderRoute("tax-rule", <TaxRules />)}
              />
              <Route
                path="/product-variants"
                element={renderRoute("product-catalog", <ProductVariants />)}
              />
              <Route
                path="/product-dimensions"
                element={renderRoute("product-catalog", <ProductDimensions />)}
              />
              <Route
                path="/pattern"
                element={renderRoute("pattern", <Pattern />)}
              />
              <Route
                path="/finish"
                element={renderRoute("finish", <FinishProducts />)}
              />
              <Route
                path="/warranty"
                element={renderRoute("warranty", <ProductWarranty />)}
              />
              <Route
                path="/bar-code"
                element={renderRoute("bar-code", <BarCode />)}
              />
              <Route
                path="/billing-products"
                element={renderRoute("billing-products", <BillingProducts />)}
              />
              <Route path="/notification" element={<NotificationList />} />

              <Route
                path="/user-permissions/:id"
                element={
                  <UserPermissions
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("admin-users")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/product-option-value/:id"
                element={
                  <ProductOptionValue
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("product-types")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/faqsList"
                element={renderRoute("faqs", <FAQList />)}
              />
              <Route
                path="/shipping-duration"
                element={renderRoute(
                  "shipping-duration",
                  <ShippingDurations />,
                )}
              />
              <Route
                path="/subTax/:id"
                element={
                  <SubTax
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("tax")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/faqsList/:id"
                element={renderRoute("faqs", <FAQList />)}
              />
              <Route
                path="/terms-and-conditions/:id"
                element={
                  <TermsConditionsList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission(
                      "terms-and-conditions",
                    )}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/privacy-policies-list/:id"
                element={
                  <PrivacyPolicyList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("privacy-policies")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/payment-policy-list/:id"
                element={
                  <PaymentPolicyList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("payment-policy")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/holidays-list/:id"
                element={
                  <HolidaysList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("holidays")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/return-policy-list/:id"
                element={
                  <ReturnPolicyList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("return-policy")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/help-and-support"
                element={renderRoute("help-support", <HelpSupport />)}
              />
              <Route
                path="/app/help-support-list/:id"
                element={
                  <HelpSupportList
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("help-support")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/inventory-form/:id"
                element={
                  <InventoryForm
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("product-inventory")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/product-inventory/:id"
                element={
                  <ProductInventory
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("product-inventory")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/store/return-address/:id"
                element={
                  <ReturnAddress
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("store")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/store/pickup-address/:id"
                element={
                  <PickupAddress
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("store")}
                    userData={userData}
                  />
                }
              />
              <Route
                path="/orders/view/:id"
                element={
                  <OrderSummary
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("orders")}
                    userData={userData}
                  />
                }
              />

              <Route
                path="/custom-orders/view/:id"
                element={
                  <ViewCustomOrders
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("custom-orders")}
                    userData={userData}
                  />
                }
              />

              <Route
                path="/delivery-management"
                element={
                  <DeliveryPartner
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission(
                      "delivery-management",
                    )}
                    userData={userData}
                  />
                }
              />

              <Route
                path="/message"
                element={
                  <DesignerMessage
                    setModuleName={setModuleName}
                    modulePermission={getModulePermission("/message")}
                    userData={userData}
                    socket={socket}
                  />
                }
              />

              <Route path="/profile" element={<Profile />} />
              <Route path="/retry-onboarding" element={<RetryOnboarding />} />
              <Route
                path="/onboarding-success"
                element={<OnboardingSuccess />}
              />
              <Route
                path="/settings"
                element={renderRoute("settings", <Settings />)}
              />
              <Route
                path="/product-catalog/bulk-upload/image-gallery"
                element={<ImageGalleryList userData={userData} />}
              />
              <Route
                path="/boosts"
                element={renderRoute("boosts", <Boosts />)}
              />
            </Routes>
          </Suspense>
        </main>
      </div>
    </div>
  );
}

export default Layout;
